<template>
  <v-card :color="nodeColor" class="workflow-node">
    <v-card-title class="d-flex font-weight-bold align-center text-center text-subtitle-2 py-2">
      <div class="mx-auto d-flex align-center">
        <v-icon v-if="isMainAgent" start size="medium">mdi-brain</v-icon>
        <v-icon v-else-if="isHelperAgent" start size="medium">mdi-account-cog</v-icon>
        <v-icon v-else-if="isTool" start size="medium">mdi-hammer-wrench</v-icon>
        <v-icon v-else-if="isEmbedding" start size="medium">mdi-vector-polyline</v-icon>
        <v-icon v-else-if="isProvider" start size="medium">mdi-cloud-outline</v-icon>
        <v-icon v-else-if="isServer" start size="medium">mdi-server</v-icon>
        <v-icon v-else-if="isMulti" start size="medium">mdi-text-box-multiple-outline</v-icon>
        <v-icon v-else-if="isRouter" start size="medium">mdi-routes</v-icon>
        <v-icon v-else-if="isRequest" start size="medium">mdi-cloud-arrow-down-outline</v-icon>
        <v-icon v-else-if="isDatabase" start size="medium">mdi-database</v-icon>
        <v-icon v-else-if="isExtRequest" start size="medium">mdi-cloud-arrow-up-outline</v-icon>
        <v-icon v-else-if="isDocs" start size="medium">mdi-file-document-outline</v-icon>
        <v-icon v-else-if="isCode" start size="medium">mdi-code-braces</v-icon>
        <v-icon v-else-if="isConfig" start size="medium">mdi-cog-outline</v-icon>
        <v-icon v-else-if="isMagic" start size="medium">mdi-magic-staff</v-icon>
        {{ label }}
      </div>
    </v-card-title>
    <!-- <Handle v-if="!isMainAgent && !isMulti" type="source" :position="Position.Bottom" />
    <Handle v-if="!isEmbedding" type="target" :position="Position.Top" /> -->
  </v-card>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Handle, Position } from '@vue-flow/core'

@Options({
  components: { Handle },
  props: {
    id: String,
    type: String,
    label: String,
    selected: Boolean,
    data: Object,
    // Include all other NodeProps to satisfy the interface if needed
    position: Object,
    dimensions: Object,
    events: Object,
    zIndex: Number,
    targetPosition: String,
    sourcePosition: String,
    dragging: Boolean,
    resizing: Boolean,
    connectable: [Boolean, String, Number, Function],
    parentNodeId: String
  }
})
export default class WorkflowNode extends Vue {
  // Props are automatically available as `this.propName`
  type!: string
  selected!: boolean
  label!: string

  // Expose Position enum to the template
  Position = Position

  get isMainAgent(): boolean {
    return this.type === 'mainAgent'
  }

  get isHelperAgent(): boolean {
    return this.type === 'helperAgent'
  }

  get isTool(): boolean {
    return this.type === 'tool'
  }

  get isEmbedding(): boolean {
    return this.type === 'embeddingCollection'
  }

  get isProvider(): boolean {
    return this.type === 'provider'
  }

  get isServer(): boolean {
    return this.type === 'server'
  }

  get isMulti(): boolean {
    return this.type === 'multi'
  }

  get isRouter(): boolean {
    return this.type === 'router'
  }

  get isRequest(): boolean {
    return this.type === 'request'
  }

  get isDatabase(): boolean {
    return this.type === 'database'
  }

  get isExtRequest(): boolean {
    return this.type === 'extRequest'
  }

  get isDocs(): boolean {
    return this.type === 'docs'
  }

  get isCode(): boolean {
    return this.type === 'code'
  }

  get isConfig(): boolean {
    return this.type === 'config'
  }

  get isMagic(): boolean {
    return this.type === 'magic'
  }

  get nodeColor(): string {
    if (this.selected) return 'warning'
    if (this.isMainAgent) return 'primary-darken-1'
    if (this.isTool) return 'success'
    if (this.isHelperAgent) return 'node-accent-1'
    if (this.isRequest) return 'secondary-darken-1'
    if (this.isMulti) return 'node-accent-1'
    if (this.isRouter) return 'node-accent-2'
    if (this.isExtRequest) return 'node-accent-2'
    if (this.isCode) return 'node-accent-2'
    if (this.isConfig) return 'node-accent-3'
    if (this.isDocs) return 'node-accent-3'
    if (this.isEmbedding) return 'node-accent-3'
    if (this.isProvider) return 'node-accent-4'
    if (this.isDatabase) return 'node-accent-4'
    if (this.isServer) return 'node-accent-5'
    if (this.isMagic) return 'node-accent-5'
    return 'grey-darken-1'
  }
}
</script>

<style>
.workflow-node {
  min-width: 220px;
  border-radius: 12px;
  transition: transform 0.16s ease, box-shadow 0.16s ease;
  cursor: pointer;
}

.workflow-node:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.18);
}
</style>
